import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_user_address',
  props: {
    currentUser: {
      type: Object
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '地址',
        addFunName: 'mngUserAddressAdd',
        modifyFunName: 'mngUserAddressModify',
        delFunName: 'mngUserAddressDel',
        queryFunName: 'mngUserAddressQuery',
        detailFunName: 'mngUserAddressDetail',
        defaultFunName: 'mngUserAddressDefault',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      dicData: {
        typeUpperCode: 'mng_address_type',
        configTypes: [],
        configTypeOptions: {}
      }
      // 地图配置
      ,
      mapConfig: {
        zoom: 12,
        center: [120.384599, 36.062687],
        activeIndex: '',
        addressList: []
      },
      searchForm: {
        page: 1,
        limit: 10,
        userId: this.currentUser.id,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        lat: null,
        lon: null,
        addressName: null,
        addressType: null,
        contactName: null,
        contactPhone: null,
        detailAddress: null,
        defultAddress: false,
        userId: this.currentUser.id
      },
      rules: {
        addressName: [{
          required: true,
          message: '地点名称不能为空',
          trigger: 'blur'
        }],
        contactName: [{
          required: true,
          message: '联系人不能为空',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '联系电话不能为空',
          trigger: 'blur'
        }],
        detailAddress: [{
          required: true,
          message: '详细地址不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(function (res) {
      if (res.data) {
        _this.dicData.configTypes = res.data;
        for (var i = 0; i < res.data.length; i++) {
          _this.dicData.configTypeOptions[res.data[i].code] = res.data[i].name;
        }
      }
      _this.query();
    });
  },
  methods: {
    back: function back() {
      this.$emit('child-go-user');
    },
    initMapByInput: function initMapByInput(clear) {
      var that = this;

      // 自动搜索插件
      AMap.plugin('AMap.Autocomplete', function () {
        var autoOptions = {
          city: '全国'
        };

        // 创建搜索范围
        var autoComplete = new AMap.Autocomplete(autoOptions);

        // 指定入参
        autoComplete.search(that.formData.detailAddress, function (status, e) {
          if (status === 'complete' && e.info === 'OK') {
            if (e.tips && e.tips.length > 0) {
              var tips = e.tips.filter(function (i) {
                return i.location && i.address.length > 0;
              });
              var tip = tips[0];
              if (typeof tip !== 'undefined') {
                that.mapConfig.center = [tip.location.lng, tip.location.lat];
              }
              that.mapConfig.addressList = tips;
            } else {
              that.mapConfig.addressList = [];
            }
          }
        });
      });
    },
    itemChange: function itemChange(n, index) {
      this.mapConfig.activeIndex = index;

      // 输入后搜索出来的，反地理编码出来的参数有所不同
      var lng = n.lng || n.longitude || n.location.lng;
      var lat = n.lat || n.latitude || n.location.lat;
      this.formData.detailAddress = (n.district || '') + ' ' + (n.name || '');
      this.formData.lon = lng;
      this.formData.lat = lat;
      this.mapConfig.zoom = 13;
      this.mapConfig.center = [lng, lat];
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this2 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this2.initFormData(res.data);
        _this2.editDialogTitle = _this2.pageConfig.editPageName + '维护';
        _this2.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this5 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this5.formData.id) {
            _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('编辑成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('编辑失败');
              }
            });
          } else {
            _this5.$api[_this5.pageConfig.addFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('新增成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};